import axios from 'axios'
import store from '../store'
import router from '../router'
import util from '@/functions'
import _ from 'lodash'

const API = axios.create({
  baseURL: process.env.API_URL + '/api/platform/v1/'
})

API.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status === 401 && error.response.data === 'user.inactive') {
    util.logoutFromBrowser(store.commit, router, store.state.websiteConfig.id)
  }
  if (error.response && error.response.status === 404 && error.response.data === 'user.no-catalog') {
    if (router.currentRoute.name === 'Single Reward') {
      // navigate to reward unavailable for single reward to avoid creating a loop
      // where /rewards/123 would redirect to /rewards/123-, then /rewards/123-- etc.
      router.replace({ name: 'RewardUnavailable', replace: true, params: { website: router.currentRoute.params.website } })
    } else {
    // mavigate to the current url with the addition of '-' so that it'd be shown as a 404
    // error but the url wouldn't be the root url of the platform website/vanity url
    // and the dashboard link on the 404 page would work correctly
    // would happen if someone navigates to one of the reward url via link/back button
    // after participant has lost the catalog relationship but before if was updated in vuex state
      router.replace({ path: router.currentRoute.path + '-' })
    }
  }
  return Promise.reject(error)
})

API.getWithOptionalAuthentication = (url, options = {}) => {
  let token = localStorage.getItem('token_' + store.state.websiteConfig.id)
  let authHeader = token != null ? { headers: {'Authorization': 'Bearer ' + token} } : {}
  let params = _.merge({}, authHeader, options)
  return API.get(url, params)
}

API.getAuthenticated = (url, options = {}) => {
  let token = localStorage.getItem('token_' + store.state.websiteConfig.id)
  let authHeader = {headers: {'Authorization': 'Bearer ' + token}}
  let params = _.merge({}, authHeader, options)
  return API.get(url, params)
}

API.postAuthenticated = (url, data, headers = {}) => {
  let token = localStorage.getItem('token_' + store.state.websiteConfig.id)
  headers.Authorization = 'Bearer ' + token
  return API.post(url, data, { headers: headers })
}

API.putAuthenticated = (url, data, headers = {}) => {
  let token = localStorage.getItem('token_' + store.state.websiteConfig.id)
  headers.Authorization = 'Bearer ' + token
  return API.put(url, data, { headers: headers })
}

API.deleteAuthenticated = (url, headers = {}) => {
  let token = localStorage.getItem('token_' + store.state.websiteConfig.id)
  headers.Authorization = 'Bearer ' + token
  return API.delete(url, { headers: headers })
}

export default API



// WEBPACK FOOTER //
// ./src/services/index.js